import {
  CalculationSettings1099Toggle,
  IPayrollSettings
} from "@wingspanhq/payments/dist/interfaces";
import { ListValueType } from "../../components/LabelValueList";

const getDetailsAndSettingsItems = (
  { calculationSettings1099 }: IPayrollSettings,
  type?: string
) =>
  [
    {
      label: "Off-platform payments included",
      value:
        calculationSettings1099?.offPlatformPayments ===
        CalculationSettings1099Toggle.Include
    },
    {
      label: "Card processing fees included",
      value:
        calculationSettings1099?.cardProcessingFees ===
        CalculationSettings1099Toggle.Include
    },
    {
      label: "Reimbursable expenses included",
      value:
        calculationSettings1099?.reimbursableExpenses ===
        CalculationSettings1099Toggle.Include
    },
    {
      label: "Form type",
      value: type ? `1099-${type}` : "-",
      type: ListValueType.Text
    }
  ].map(item => ({
    ...item,
    id: item.label,
    type: typeof item.type !== "undefined" ? item.type : ListValueType.Boolean
  }));

export default getDetailsAndSettingsItems;
